import { FC } from 'react';
import { CatalogButton } from './styles';
import { PostTextCatalogLinkProps } from './types';

export const PostTextCatalogLink: FC<PostTextCatalogLinkProps> = ({
    post,
    onPostTextCatalogClick,
}) => {
    const { business } = post;

    if (!business?.catalogUrl) {
        return null;
    }

    return <CatalogButton business={business} onClick={onPostTextCatalogClick} />;
};
